import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  type: "object",
  name: "faqGroupQuestions",
  title: "FAQ Group Questions",
  preview: {
    select: {
      title: "question"
    },
    prepare({ title }) {
      return { title: multilingualStringPreview(title) };
    }
  },
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "questions",
      title: "Questions",
      type: "array",
      of: [{ type: "faqQuestion" }]
    }
  ]
});
